export default "__VITE_ASSET__Dmrt7MQm__"